// A link that opens one incident.
//
// `/incidents?open=<id>` is the app's only deep link into a record: the Incidents
// page reads it on mount, fetches that incident and switches to its event (see
// pages/Incidents.jsx). The backend builds the same URL for the SMS a share or a
// reallocation sends (core/incident_shares.py) and for a review reminder, from
// config.FRONTEND_ORIGIN; here the origin is the one the reader is already on, so
// a link copied out of the app can't point at a different deployment.
//
// Its own module because three unrelated places need it — the incident dialog's
// copy button, the Excel export's Link column, and the patient-history panel's
// row links — and none of them should have to know the query parameter's name.

export const incidentLink = (id) => `${window.location.origin}/incidents?open=${id}`;
